
export const navList = [
  { path: '/home', name: '首页' },
  { path: 'production', name: '产品介绍', type: 1, children: [{ path: '/production/ssLive', name: '双师直播课' }, { path: '/production/ai', name: 'AI课' }, { path: '/production/content', name: '未来好课' }, { path: '/production/shuangshi', name: '双师小组课' }] },
  { path: '/success-info', name: '成功案例' },
  { path: '/download', name: '下载中心' },
  { path: 'about_us', name: '关于我们', type: 2, children: [{ path: '/about_us', name: '关于我们', subTitle: '全球优质科技教育产品供应平台' }, { path: '/about_us/news_center/list', name: '媒体报道', subTitle: '未来魔法校最新动态' }] }
]
export const footerNavList = [
  { path: '', name: '产品介绍', type: 1, children: [{ path: '/production/ssLive', name: '双师直播课' }, { path: '/production/ai', name: 'AI课', subTitle: '致力于因材施教的新模式' }, { path: '/production/content', name: '未来好课', subTitle: '助力传统课堂教研标准化' }, { path: '/production/shuangshi', name: '双师小组课', subTitle: '实现好老师的分配共享' }] },
  { path: '', name: '成功案例', children: [{ path: '/success-info', name: '成功案例', subTitle: '' }] },
  { path: '', name: '关于我们', type: 2, children: [{ path: '/about_us', name: '关于我们', subTitle: '全球优质科技教育产品供应平台' }, { path: '/about_us/news_center/list', name: '媒体报道', subTitle: '未来魔法校最新动态' }] }
]
export const physicsTeachers = [
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/taohuangfan.png',
    name: '陶皇帆',
    des1: '老师教龄：好未来8年教龄',
    des2: '教师资格证编号：20094106442001063 ',
    text: '好未来8年教龄，原好未来学科产品、教师培训负责人，毕业年级”把关”教师，主带中考及高考课程。课堂气氛火爆、幽默，曾撰写教案50万字，设计200余个经典物理演示实验，深受学生喜爱。'
  }
]
export const languageTeachers = [
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/mashanshan.png',
    name: '马姗姗',
    des2: '教师资格证编号：2017432001364 ',
    text: '多年教学经验，大语文教研骨干成员，内部统编教材负责人。亲和力强，亦师亦友，严肃而不失活泼的课堂环境，让学生学习乐在其中，难以自拔。'
  },
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/caiqiao.png',
    name: '采桥',
    des1: '毕业院校：北京师范大学',
    des2: '教师资格证编号：20171100151003137 ',
    text: '科研能手，本科期间参与两项国家级科研项目，编辑专家，参与编写《中国教育大百科全书》传媒先锋， “老干部”，十二年班长、北师大学生团体联合会主席。教学思路清晰，全科思维，注重孩子逻辑性的养成。课堂风格深入浅出，风趣幽默。通过让孩子对语文的学习，更加热爱生活，更会品味生活。'
  }
]
export const englishTeachers = [
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/shimohua.png',
    name: '石默华',
    des1: '毕业院校：英国南安普顿大学硕士',
    des2: '教师资格证编号：20123717033123321 ',
    text: '前新东方五星听口名师，现魔法校英语S级主讲，国外知名企业多年工作经验，帮助上万学生脱口而出标准美音。'
  },
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/shihang.png',
    name: '史航',
    des1: '毕业院校：河北大学',
    des2: '教师资格证编号：20091360142000073 ',
    text: '担任英语教研教学工作十年，曾负责编写过多本英语教材，曾在培训机构大人教学主管，曾任线上教研总监。'
  },
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/sundongmei.png',
    name: '孙冬梅',
    des1: '毕业院校：辽宁师范大学',
    des2: '教师资格证编号：20074112041001065 ',
    text: '担任英语一线教学工作十余年，深谙学生心理，擅长正向引导学生。精于教学技巧，授课生动形象。能够照顾到学生的心理特点和接受能力。'
  },
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/wangyirui.png',
    name: '王祎瑞',
    des1: '毕业院校：中国矿业大学（北京）',
    des2: '教师资格证编号：2018134079588 ',
    text: '五年学科英语、线上、线下教学经验，学而思S级教师，轻松诙谐，灵活多变，通俗易懂，深入浅出。善于培养学生的学习方法和习惯。'
  },
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/zhangmingyue.png',
    name: '张明月',
    des1: '毕业院校：北方工业大学',
    des2: '教师资格证编号：2018134079490 ',
    text: '英语专业八级，持有剑桥TKT英语教学能力证书，学而思在线优秀主讲，原学而思在线初中英语教研负责人。'
  },
  {
    avatar: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/zhujun.png',
    name: '朱俊',
    des1: '毕业院校：华中师范大学',
    des2: '教师资格证编号：20064106442001058 ',
    text: '8年教龄，未来魔法校S级老师，原学而思在线英语负责人，未来魔法校英语负责人，全国大学生演讲比赛金奖，10万人口语教练。'
  }
]
export const cooperationDemo = {
  1: [
    {
      img: '',
      school_name: '武汉优杰教育机构',
      school_des: '“通过未来好课完善的学科内容体系，强大的教研支持，提升了机构自有教研体系的竞争力，帮助我们机构实现进一步发展。”',
      president: '— 武汉优杰教育校长',
      coop_date: '2019-10',
      coop_type: '未来好课'
    },
    {
      img: '',
      school_name: '韩城放飞梦想培训中心',
      school_des: '“未来好课的课程体系，完整的运营服务支持以及智能课堂服务系统，让我们的数学教学团队快速成长起来，稳定实现数学扩科。”',
      president: '— 韩城放飞梦想培训中心校长',
      coop_date: '2019-05',
      coop_type: '未来好课'
    },
    {
      img: '',
      school_name: '福州市起点培训中心',
      school_des: '“未来好课标准的备课流程、高效的教学方法和完整的备授课服务体系，整体提升了我们的教学质量，帮助年轻老师快速成长。”',
      president: '— 福州起点培训中心校长',
      coop_date: '2019-05',
      coop_type: '未来好课'
    },
    {
      img: '',
      school_name: '保定拓普教育',
      school_des: '“我感觉自己就是好未来人，从合作的第一天起，好未来对我们就像直营校一样毫无保留地全力扶持。”',
      president: '— 保定拓普教育高校长',
      coop_date: '2020-03',
      coop_type: '未来好课'
    }
  ],
  2: [
    {
      img: '',
      school_name: '平舆麦田',
      school_des: '“希望一款能够满足中国孩子英语学习需求的产品能够帮助更多孩子走上科学的英语学习之路！”',
      president: '— 校长寄语',
      coop_date: '2019-03',
      coop_type: '乐外教英语'
    },
    {
      img: '',
      school_name: '河南爱上课',
      school_des: '“紧跟行业标杆，提升综合能力，成就更多学生”',
      president: '— 校长寄语',
      coop_date: '2019-01',
      coop_type: '双师+乐外教英语'
    }
  ]
}
export const methodScrollConfig = {
  navList: [
    {
      main: '6',
      sub: '大教学模式'
    },
    {
      main: '7',
      sub: '步备课法'
    },
    {
      main: '8',
      sub: '步教学法'
    }
  ],
  imgList: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-1.png',
      width: 933,
      height: 258
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-2.png',
      width: 888,
      height: 485
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-3.png',
      width: 824,
      height: 477
    }
  ],
  sectionHeight: [0, 520, 1040],
  boxHeight: 520,
  id: 'methods-wrapper'
}
export const serviceScrollConfig = {
  navList: [
    {
      main: '3',
      sub: '大运营支持'
    },
    {
      main: '4',
      sub: '大服务系统'
    },
    {
      main: '5',
      sub: '大教学场景'
    }
  ],
  imgList: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-4.png',
      width: 775,
      height: 297
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-5.png',
      width: 772,
      height: 581
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-6.png',
      width: 797,
      height: 358
    }
  ],
  sectionHeight: [0, 581, 1162],
  boxHeight: 581,
  id: 'service-wrapper'
}
export const contentTeacherTeam = {
  main: '清北老师领衔教研团队',
  sub: '将优质教案输出到更多机构',
  typeName: '未来好课',
  typeTitle: '清北教研团队',
  typeDes: '清北名校背景教研老师领衔教研团队，秉承“精于研、简于教”的理念，输出教研体系化、备课专业化、课件标准化的教学方案，助力机构突破教研教学瓶颈，全面提升面授课堂质量与体验。',
  teacherUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/teacher-content.png'
}
export const ssTeacherTeam = {
  main: '清北老师领衔主讲团队',
  sub: '将优质教育资源共享给更多的孩子',
  typeName: '双师小组课',
  typeTitle: '清北主讲团队',
  typeDes: '清北名校背景主讲老师领衔主讲团队，严苛录取；<br>他们扎实的专业知识，先进的教育理念，成就对学生教育知识的传承 ',
  teacherUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/teacher-ss.png'
}
export const ssLiveTeacherTeam = {
  main: '清北老师领衔主讲团队',
  sub: '将优质教育资源共享给更多的孩子',
  typeName: '双师直播课',
  typeTitle: '清北主讲团队',
  typeDes: '清北名校背景主讲老师领衔主讲团队，严苛录取；<br>他们扎实的专业知识，先进的教育理念，成就对学生教育知识的传承 ',
  teacherUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/teacher-ss.png'
}
export const cloudList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-1.png',
    main: '课中互动系统',
    sub: '集成多种趣味互动形式，利用“互动系统+答题器”打造沉浸式课堂。'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-2.png',
    main: '教务管理系统',
    sub: '助力机构日常管理，提供班级创建、学员管理、教师管理、校区管理等功能。'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-3.png',
    main: '学生端',
    sub: '贯穿学习各个阶段，包括预习、课前测、课上学习、笔记、课后练、课后复习等，定期生成学习报告，实现学习过程透明化、学习效果可视化。'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-4.png',
    main: '辅导端',
    sub: '支持作业客观题系统自动批改、主观题在线批改及在线备课功能，在线查看学生学习数据，提供针对性教学服务，协助老师日常工作。'
  }
]
export const supportList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/support-1.png',
    main: '名师直播间',
    des: '名师授课，与机构共享优质教学资源'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/support-2.png',
    main: '辅导老师在线伴学',
    des: '辅导老师在线关注每个学生学习情况'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/support-3.png',
    main: '学生线上学习',
    des: '学生随时随地在线上课'
  }
]
export const supportLiveList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/live-support-1.png',
    main: '名师直播间',
    des: '名师授课，与机构共享优质教学资源'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/live-support-2.png',
    main: '智慧教室',
    des: '辅导老师全程伴学，答疑解惑'
  }
]
export const learnList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/student-1.png',
    main: '办学无场地限制',
    des: '主讲和辅导老师课中与学生高频互动，让孩子学习更加高效'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/student-2.png',
    main: '辅导老师在线伴学',
    des: '让每个学生都被关注'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/student-3.png',
    main: '课中互动至少10分钟1次',
    des: '让学生上课更有参与感'
  }
]
export const liveOperateList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/live-operate-1.png',
    main: '爆品课引流',
    des: '大IP爆品课物料支持，帮助机构解决招生难题'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/live-operate-2.png',
    main: '机构老师培训',
    des: '未来魔法校助力机构健康成长'
  }
]
export const supportAiList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-1-1.png',
    main: '哈佛外教授课',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-1-2.png',
    main: '课堂高频互动效果好',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-1-3.png',
    main: '随时开班、周期灵活',
    des: ''
  }
]
export const learnAiList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-1.png',
    main: '真实教学场景',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-2.png',
    main: '课中超过300次开口互动',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-3.png',
    main: '运用趣味动画，引入流行IP',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-4.png',
    main: 'AI智能判断学生学习状态',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-5.png',
    main: '课后阅读可听可练可读可玩',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-6.png',
    main: '让孩子真正爱上学习',
    des: ''
  }
]
export const achieveList = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/achievement-1.png',
    des: '好未来与清华大学、斯坦福大学及中科院计算所达成合作'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/achievement-2.png',
    des: '科技部批准依托好未来建设智慧教育国家新一代人工智能开放创新平台'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/achievement-3.png',
    des: '斯坦福大学-好未来联合项目签约仪式'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/achievement-4.png',
    des: '好未来与北京师范大学等6所高校专家启动联合项目'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/achievement-5.png',
    des: '清华大学计算机系与好未来共同成立“清华大学-好未来”智能教育信息技术联合研究中心'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/achievement-6.png',
    des: '2019年9月，未来魔法校和剑桥大学出版社达成战略合作'
  }
]
export const productSolutionList = [
  {
    type_id: 1,
    type_name: '双师直播课',
    type_des: '名师主讲授课，解决机构招老师难问题，助力扩展学科',
    tea_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-tea1.png',
    bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-bg1.png',
    img_des: '19+教学经验'
  },
  {
    type_id: 2,
    type_name: '双师小组课',
    type_des: '名师主讲授课，学生在家上课，助力解决疫情期间复课问题',
    tea_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-tea2.png',
    bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-bg2.png',
    img_des: '名校背景老师'
  },
  {
    type_id: 3,
    type_name: 'AI课',
    type_des: '哈佛外教授课，可随时开课，让招生不再受困于老师班期',
    tea_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-tea3.png',
    bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-bg3.png',
    img_des: '哈佛外教'
  },
  {
    type_id: 4,
    type_name: '未来好课',
    type_des: '17年教研数据沉淀，千人教研团队持续支持，帮助机构提升教学质量',
    tea_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-tea4.png',
    bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-pro-bg4.png',
    img_des: '17年教研沉淀'
  }
]
export const solutionList = [
  {
    index: '01',
    name: '学员招生',
    children: [
      {
        id: 1,
        name: '品牌支持',
        des: '主讲团队的包装，产品宣传物料和魔法校的品牌背书',
        isPortrait: true,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-1-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-1-2.jpg'
        ]
      },
      {
        id: 2,
        name: '物料支持',
        des: '招生+宣传海报，课程内容+题库资料',
        isPortrait: true,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-2-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-2-2.jpg'
        ]
      },
      {
        id: 3,
        name: '运营工具支持',
        des: '学员测评+海报自定义工具+打卡签到助手',
        isPortrait: true,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-3-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-3-2.jpg'
        ]
      },
      {
        id: 4,
        name: '招生支持',
        des: '爆品招生课+招生培训，活动方案+伴跑活动',
        isPortrait: true,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-4-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-1-4-2.jpg'
        ]
      }
    ]
  },
  {
    index: '02',
    name: '学员上课',
    children: [
      {
        id: 5,
        name: '名师课堂',
        des: '共享一线教育资源',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-2-1-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-2-1-2.jpg'
        ]
      },
      {
        id: 6,
        name: '专业教研',
        des: '17年深厚沉淀',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-2-2-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-2-2-2.jpg'
        ]
      },
      {
        id: 7,
        name: 'AI课',
        des: '把前沿科技融入教学',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-2-3-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-2-3-2.jpg'
        ]
      }
    ]
  },
  {
    index: '03',
    name: '课后+家校沟通',
    children: [
      {
        id: 8,
        name: '作业自动批改',
        des: '解放老师课后精力，实现更多带班',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-3-1-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-3-1-2.jpg'
        ]
      },
      {
        id: 9,
        name: '学员学习报告',
        des: '更多维度解读孩子学情状况',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-3-2-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-3-2-2.jpg'
        ]
      }
    ]
  },
  {
    index: '04',
    name: '续费周期运营',
    children: [
      {
        id: 10,
        name: '校长培训学院+三板斧',
        des: '未来魔法校陪着校长们一起成长',
        isPortrait: true,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-4-1-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-4-1-2.jpg'
        ]
      },
      {
        id: 11,
        name: '机构老师培训',
        des: '解决机构招老师难的问题',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-4-2-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-4-2-2.jpg'
        ]
      },
      {
        id: 12,
        name: '教学质量监控',
        des: '课中+课后学员学习情况监测，帮助机构在续费周期前介入维护关怀',
        isPortrait: false,
        imgs: [
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-4-3-1.jpg',
          'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/operationSystem/ope-sys-4-3-2.jpg'
        ]
      }
    ]
  }
]
